function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "rating-18_svg__a",
  d: "M0 0h80v79.999H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "rating-18_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#rating-18_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M40 78.597C18.686 78.597 1.404 61.317 1.404 40 1.404 18.684 18.686 1.404 40 1.404c21.316 0 38.598 17.28 38.598 38.596 0 21.317-17.282 38.597-38.598 38.597M40 0C17.909 0 0 17.909 0 40c0 22.092 17.91 39.999 40 39.999 22.092 0 40-17.907 40-40C80 17.91 62.092 0 40 0",
  fill: "#000",
  mask: "url(#rating-18_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40 75.088c-19.378 0-35.087-15.708-35.087-35.087C4.913 20.623 20.622 4.913 40 4.913c19.379 0 35.088 15.71 35.088 35.088 0 19.379-15.71 35.087-35.088 35.087m0-73.684C18.686 1.403 1.404 18.683 1.404 40S18.686 78.596 40 78.596c21.316 0 38.598-17.28 38.598-38.596C78.598 18.685 61.316 1.404 40 1.404",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40 4.912C20.622 4.912 4.913 20.622 4.913 40c0 19.38 15.709 35.088 35.087 35.088 19.379 0 35.088-15.709 35.088-35.088 0-19.378-15.71-35.088-35.088-35.088",
  fill: "#DC0A0A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.18 25.52v28.078h-5.114V37.542c0-2.662 0-3.452-2.29-3.452h-4.575v-3.203h.54c2.623-.042 6.159-.083 7.282-5.366h4.157zm24.326 20.008c0 5.116-4.408 8.443-10.522 8.443-6.408 0-10.36-3.576-10.36-8.443 0-4.41 3.204-5.948 4.618-6.613-2.995-1.415-3.618-4.452-3.618-6.115 0-4.368 3.618-7.738 9.65-7.738 5.783 0 9.567 3.12 9.567 7.987 0 2.455-1 4.575-3.661 5.866 3.245 1.622 4.326 4.034 4.326 6.613m-15.017-.166c0 2.37 1.665 3.993 4.744 3.993 2.704 0 4.7-1.415 4.7-4.036 0-.498-.083-3.992-4.7-3.992-4.452 0-4.744 3.161-4.744 4.035m.459-11.938c0 1.248.54 3.701 4.327 3.701 3.287 0 4.118-2.12 4.118-3.7 0-3.205-2.538-3.787-4.16-3.787-3.537-.04-4.285 2.246-4.285 3.786",
  fill: "#FFF"
}));

function SvgRating18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2);
}

export default SvgRating18;